import { PLACEMENT_MAP } from './constants';
import { type Placement, type PlacementWitDashAlignment } from './types';

export function mapPlacement(placement: PlacementWitDashAlignment | Placement) {
  if (placement.includes('-')) {
    return PLACEMENT_MAP[placement as keyof typeof PLACEMENT_MAP];
  }
  return placement as Placement;
}
